<template>
	<div class="mx-3 mx-lg-0 position-relative">
		<div class="row overflow-hidden tabs-wrapper">
			<!-- desktop -->
			<div
				class="w-100 font-size-14 d-none d-lg-flex flex-row justify-content-between align-items-around"
				ref="packagesContainer">
				<div
					v-for="(option, option_i) in options"
					:key="`${option}-${option_i}`"
					:style="{ width: tabWidth }"
					:class="
						option.selected
							? 'active font-weight-700'
							: 'text-grey-900'
					"
					class="package-tab"
					@click="option.action">
					<div class="tab-inner-wrapper">
						<div class="d-flex justify-content-end align-items-center">
							<RadioCircle
								:active="option.selected"
								:colorDefault="'var(--primary-blue)'"
								:colorActive="'white'"
								:additionalClasses="'me-1 me-xl-3'" />
						</div>
						<span
							class="d-flex justify-content-center align-items-center pack-code">
							<span class="d-flex align-items-center">
								{{ option.label }}
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import {  computed, nextTick, onMounted, ref} from "vue"
import { useStore } from "vuex"
import RadioCircle from "@/vue/common/radioCircle.vue"
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import { Transport } from "@/types"

type SwitchOption = {
	label: string
	action: () => void
	selected: boolean
}

// Props
const props = defineProps({
	packagesToDisplay: {
		type: Array,
		default: () => [],
	},
})

// Store
const store = useStore()

// Reactive variables
const selectedTransport = ref<Transport | null>(null)

// Computed properties
const content = computed(() => store.state.content)

// TODO will probably need to select a packCode here(transport or non)
const options = computed<SwitchOption[]>(() => {

	const isFlightEnabled = store.getters.availablePackCodes.some((pack: { codePackage: string }) => flightPackCode.includes(pack.codePackage)) 
	const isTrainEnabled = store.getters.availablePackCodes.some((pack: { codePackage: string }) => trainPackCode.includes(pack.codePackage))

	const options: SwitchOption[]=[];
	if (isFlightEnabled) {
		options.push(
		{
			label: content.value.transport_flight,
			action: () => handleSwitch(Transport.FLIGHT),
			selected: selectedTransport.value === Transport.FLIGHT
		});
	} 
	if (isTrainEnabled) {
		options.push({
			label: content.value.transport_train,
			action: () => handleSwitch(Transport.TRAIN),
			selected: selectedTransport.value === Transport.TRAIN
		});
	}
	options.push({
		label: content.value.transport_none,
		action: () => handleSwitch(null),
		selected: selectedTransport.value === null
	});

	return options
})

const tabWidth = computed(() => {
	return `${100 / (options.value.length || 1)}%`
})
// Methods
// const selectTransport = (select: boolean): void => {
// 	store.dispatch("selectTransportWithDefaultPackage", select)
// }
const handleSwitch = async (transport: Transport | null) => {
	// console.log("XXX handleSwitch", transport)
	selectedTransport.value = transport;
	store.commit("setTransportv2", transport);
	// store.commit("setDefaultPackageForOriginType", origin);
	await store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
	// console.log("XXX packagesToDisplay", packagesToDisplay.value)
	// store.commit("setTransport", transport==='FLIGHT' || transport==='TRAIN')
	// store.commit("setTransportationSelected", transport==='FLIGHT' || transport==='TRAIN')
	// await store.dispatch("selectTransportWithDefaultPackage", transport==='FLIGHT' || transport==='TRAIN')
	// console.log("XXX packagesToDisplay.value[0].codePackage", packagesToDisplay.value[0].codePackage)


	if (transport===Transport.FLIGHT) {
		store.commit("setTransportationSelected", true)
		// Always select the first available origin when switching to a flight package tab
		await store.dispatch("selectDefaultFlightOrigin", { overwrite: true, forceFlightPackCode: true })
	} else if (transport===Transport.TRAIN) {
		store.commit("setTransportationSelected", true)
		// Always select the default train origin when switching to a train package tab
		await store.dispatch("selectDefaultTrainOrigin", { overwrite: true, forceTrainPackCode: true })
	} else {
		store.commit("setTransportationSelected", false)
	}
	// Old stuff TO BE REMOVED
	// store.commit("setTransport", transport==='FLIGHT' || transport==='TRAIN')
	// store.commit("setTransportationSelected", transport==='FLIGHT' || transport==='TRAIN')
	// store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
	// store.dispatch("selectTransportWithDefaultPackage", transport==='FLIGHT' || transport==='TRAIN')
}


onMounted(() => {
	// console.log("XXX onMounted", store.getters.transportv2)
	
	if (flightPackCode.includes(store.state.packCode)) {
		selectedTransport.value = Transport.FLIGHT;
		store.commit("setTransportv2", Transport.FLIGHT);
	}
	else if (trainPackCode.includes(store.state.packCode)) {
		selectedTransport.value = Transport.TRAIN;
		store.commit("setTransportv2", Transport.TRAIN);
	}
	else {
		selectedTransport.value = null;
	}
})
</script>

<style scoped>
.tab-inner-wrapper {
	display: grid;
	grid-template-columns: 70px 1fr 70px;
}

.package-tab {
	background: white;
	border-bottom: 1px solid #dee2e6;
	flex-grow: 1;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background 150ms ease-in-out, color 150ms ease-in-out,
		box-shadow 150ms ease-in-out;
}
.package-tab:hover:not(.active) {
	color: var(--primary-blue);
	box-shadow: inset 0px 0px 0px 1px var(--primary-blue) !important;
}
.package-tab:hover:not(.active) .icon {
	color: var(--primary-blue);
}
/* .tab.active:hover {
    background: #305c8b;
} */
.package-tab:not(:first-child) {
	border-right: 1px solid #dee2e6;
}
.package-tab:not(:last-child) {
	border-left: 1px solid #dee2e6;
}
.package-tab:last-child,
.package-tab:first-child {
	border-left: none;
	border-right: none;
}
.package-tab.active {
	background: var(--primary-blue);
	border: none;
	color: white;
}

.package-tab:first-child {
	border-top-left-radius: 16px;
}

.package-tab:last-child {
	border-top-right-radius: 16px;
}

.tabs-wrapper {
	border-radius: var(--border-radius-secondary) var(--border-radius-secondary) 0 0;
	display: flex !important;
	flex-wrap: wrap !important;
	margin-right: -15px !important;
	margin-left: -15px !important;
	--bs-gutter-x: 0 !important;
}

.mobile-packages-wrapper,
.mobile-packages {
	border-radius: 8px;
}

.prestation-discount-container {
	border-radius: 37px;
}

.font-size-11 {
	font-size: 11px;
}

.font-size-12 {
	font-size: 12px;
}

.font-size-14 {
	font-size: 14px;
}
</style>
